import productData from "../data/products";

const products = (state = productData, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default products;



// WEBPACK FOOTER //
// ./src/reducers/products.js